import React,{Component} from 'react';

import PropTypes from 'prop-types';

import { DataGrid, GridColDef, GridSortModel, GridRowId } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import GridToolbar from './GridToolbar';
import { Box } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import GridFilterPanel from './GridFilterPanel';
import GridAdvancedFilterPanel from "./GridAdvancedFilterPanel";
import AIQueryAssistant from "./AIQueryAssistant";
import { buildModuleQueryFromFilterModel } from "./FilterModelMapper";

const s:any = {
  root: {
    width: '100%',
    mt: 1,
  },
  tableWrapper: {
    width: '100%',
    overflow: 'hidden',
  },
  datagrid: {
    width: '100%',
    minWidth: 0,
    border: 'none',
    '& .MuiDataGrid-main': {
      minWidth: 0,
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#F8FAFB',
      borderBottom: '1px solid #E2E8EE',
      minHeight: '46px !important',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 700,
      fontSize: 13,
      color: '#33495C',
    },
    '& .MuiDataGrid-cell': {
      padding: '0 10px',
      borderBottom: '1px solid #EEF2F4',
      fontSize: 13,
      color: '#33495C',
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#F8FAFB',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: '1px solid #E2E8EE',
      backgroundColor: '#FFFFFF',
    },
  }
};

class GridPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      sortModel: this.props.orderBy ? [{ field: this.props.orderBy, sort: this.props.order || 'asc' }] : [],
      selected: [],
      cols: props.rows.map((row:any)=>row.id),
      rows: props.rows,//this.props.rows,
      data: props.data,//this.props.data,
      page: props.page || 0,//this.props.page || 0,
      total: props.recordCount,
      rowsPerPage: props.rowsPerPage||10,//this.props.rowsPerPage||5,
      selectedRecord: null,
      selectedIndex: null,
      actions: [],
      rowSelectionModel: [] as GridRowId[],
      filterOpen: false,
      //filterOpen: false,
      aiOpen: false,
      filterModel: {
        search: "",
        defaultField: "",
        conditions: [],
      },
    };
  }

  onSortModelChange = (sortModel: GridSortModel) => {
    this.setState({ sortModel });
  };

  onRowSelectionModelChange = (rowSelectionModel: GridRowId[]) => {
    const selectionArray: GridRowId[] = Array.isArray(rowSelectionModel) ? rowSelectionModel : [];
    const selectedId = selectionArray.length > 0 ? selectionArray[0] : null;
    
    if (selectedId === null) {
      this.setState({ 
        selected: [], 
        selectedRecord: null, 
        selectedIndex: null, 
        actions: [],
        rowSelectionModel: []
      });
      return;
    }

    // Find the selected row
    const row = this.props.data?.find((d:any) => d.id === selectedId);
    
    if (row && row.rid !== undefined) {
      const item = this.props.data?.find((d:any) => d.rid === row.rid);
      console.log('Actual row to display', item);

      const { actions } = this.props;
      const actype = typeof actions;
      const gridactions = Array.isArray(actions) ? actions
                        : (actype === 'function') ? actions(row?.id, item)
                        : (actype === 'object') ? Object.keys(actions)
                        : (actype === 'string') ? [actions] : [];

      this.setState({ 
        selected: [row?.rid], 
        selectedRecord: item, 
        selectedIndex: row?.id, 
        actions: gridactions,
        rowSelectionModel: selectionArray
      });
    }
  };

  onPageChange = (page: number) => {
    this.setState({ page });
  };

  onPageSizeChange = (pageSize: number) => {
    this.setState({ rowsPerPage: pageSize });
  };

  setGridActions = (event:any,selected:any,item:any) => {
    const { actions } = this.props;
    const actype = typeof actions;
    const gridactions = Array.isArray(actions) ? actions
                      : (actype === 'function') ? actions(event?.id, item)
                      : (actype === 'object') ? Object.keys(actions)
                      : (actype === 'string') ? [actions] : [];

    this.setState({ 
      selected: [selected?.rid], 
      selectedRecord: item, 
      selectedIndex: event?.id, 
      actions: gridactions,
      //rowSelectionModel: selectionArray
    });
  };

  initGridActions = () => {
    const { actions, cancreate } = this.props;
    const actype = typeof actions;
    const gridactions = Array.isArray(actions) ? actions
                      //: (actype === 'function') ? actions(event?.id, item)
                      : (actype === 'object') ? Object.keys(actions)
                      : (actype === 'string') ? [actions] : [];
    if(!(gridactions.includes('add')) && (cancreate)){
      gridactions.push('add');
    }
    this.setState({ 
      actions: gridactions,
    });
  };

  componentDidMount() {
    // Ensure rowSelectionModel is always initialized
    if (!Array.isArray(this.state.rowSelectionModel)) {
      this.setState({ rowSelectionModel: [] });
    }

    // Set allowable actions in state
    this.initGridActions();
  }

  componentDidUpdate(prevProps: any) {
    // Reset selection if data changes significantly
    if (prevProps.data !== this.props.data && this.state.rowSelectionModel.length > 0) {
      const currentSelection = this.state.rowSelectionModel[0];
      const exists = (this.props.data || []).some((row: any) => 
        (row.id === currentSelection) || (row.rid === currentSelection)
      );
      if (!exists) {
        this.setState({ 
          rowSelectionModel: [],
          selected: [],
          selectedRecord: null,
          selectedIndex: null,
          actions: []
        });
      }
    }
  }

  onRowSelect = (event:any, row:any) => {
    //event.preventDefault();

    //find item
    if(this.state.selectedIndex === event?.id){
      return;
    }

    const selected = this.props.data?.find((d:any) => d.rid === row?.rid);
    console.log("selected",selected)
    
    if (selected && selected.rid !== undefined) {
      const item = this.props.data?.find((d:any) => d.rid === selected.rid);
      //console.log('Actual row to display', item);

      // compute grid actions
      const { actions } = this.props;
      const actype = typeof actions;
      const gridactions = Array.isArray(actions) ? actions
                        : (actype === 'function') ? actions(event?.id, item)
                        : (actype === 'object') ? Object.keys(actions)
                        : (actype === 'string') ? [actions] : [];

      this.setState({ 
        selected: [selected?.rid], 
        selectedRecord: item, 
        selectedIndex: event?.id, 
        actions: gridactions,
        //rowSelectionModel: selectionArray
      });
    }
  };

  toggleFilter = () => {
    this.setState((prev: any) => ({ filterOpen: !prev.filterOpen }));
  };

  closeFilter = () => {
    this.setState({ filterOpen: false });
  };

  handleFilterApply = () => {
    // trigger search or reload
    this.props.refresh?.();
  };

  handleFilterReset = () => {
    // reset filters
    this.props.refresh?.({});
  };

  // toggleFilter = () => {
  //   this.setState((prev: any) => ({ filterOpen: !prev.filterOpen }));
  // };

  // closeFilter = () => {
  //   this.setState({ filterOpen: false });
  // };

  openAi = () => {
    this.setState({ aiOpen: true });
  };

  closeAi = () => {
    this.setState({ aiOpen: false });
  };

  handleAdvancedFilterApply = (model: any) => {
    const payload = buildModuleQueryFromFilterModel(this.props.sdata, model);
    this.setState({ filterModel: model, aiOpen: false });

    this.props.refresh?.(payload);
  };

  render() {
    const { search, query, title, sdata, rows, data, formatters, actionSet, onAction, handleSelect, refresh, setColumns, filterColumns, classes } = this.props;
    const { recordCount, pageMode, page: rempage, onPageChange: onRemotePageChange, onRowsPerPageChange: onRemoteRowsPerPageChange } = this.props;
    const { selected, selectedRecord, actions, sortModel, rowsPerPage, page: locpage, cols, rowSelectionModel } = this.state;
    
    const isRemote = (pageMode === 'remote');
    const page = isRemote ? rempage : locpage;
    const rowCount = isRemote ? recordCount : (data?.length || 0);
    const fm = formatters || {};
    const frows = filterColumns(rows, cols);
    // Ensure rowSelectionModel is always a valid array of GridRowId 
    const safeRowSelectionModel: GridRowId[] = Array.isArray(rowSelectionModel) ? rowSelectionModel : [];
    
    // Convert column definitions to DataGrid format
    const totalCols = frows.length;

    // const columns: GridColDef[] = frows.map((col: any, index: number) => {
    //   // const isWideCandidate =
    //   //   ["nam", "rfn", "dsc", "description", "remarks", "rmk", "unn", "stn", "title"].includes(col.id);
    //   const isWideCandidate = ["rmk", "dsc"].includes(col.id);

    //   const hasExplicitWidth = col.width !== undefined && col.width !== null;

    //   const useFlex =
    //     col.flex !== undefined
    //       ? col.flex
    //       : hasExplicitWidth
    //       ? undefined
    //       : totalCols <= 6
    //       ? (isWideCandidate ? 1.4 : 1)
    //       : totalCols <= 9
    //       ? (isWideCandidate ? 1.2 : undefined)
    //       : undefined;

    //   return {
    //     field: col.id,
    //     headerName: col.label || col.id,
    //     minWidth: col.minWidth || col.width || (isWideCandidate ? 160 : 90),
    //     flex: useFlex,
    //     width: useFlex ? undefined : (col.width || (isWideCandidate ? 180 : 110)),
    //     sortable: true,
    //     disablePadding: col.disablePadding || false,
    //     align: col.numeric ? 'right' : 'left',
    //     headerAlign: col.numeric ? 'right' : 'left',
    //     renderCell: (params: any) => {
    //       const value = params.value;
    //       const row = params.row;

    //       if (fm[col.id]) return fm[col.id](value, row);

    //       return (
    //         <Box
    //           sx={{
    //             width: '100%',
    //             overflow: 'hidden',
    //             textOverflow: 'ellipsis',
    //             whiteSpace: 'nowrap',
    //           }}
    //           title={value !== null && value !== undefined ? String(value) : ''}
    //         >
    //           {value !== null && value !== undefined ? String(value) : ''}
    //         </Box>
    //       );
    //     },
    //   };
    // });

    const columns: GridColDef[] = frows.map((col: any) => {
      const isWideCandidate = [
        "nam",
        "rfn",
        "dsc",
        "description",
        "remarks",
        "rmk",
        "unn",
        "stn",
        "title",
      ].includes(col.id);

      return {
        field: col.id,
        headerName: col.label || col.id,
        width: col.width || (isWideCandidate ? 180 : 110),
        minWidth: col.minWidth || (isWideCandidate ? 150 : 90),
        flex: col.flex !== undefined ? col.flex : undefined,
        sortable: true,
        disablePadding: col.disablePadding || false,
        align: col.numeric ? "right" : "left",
        headerAlign: col.numeric ? "right" : "left",
        renderCell: (params: any) => {
          const value = params.value;
          const row = params.row;

          if (fm[col.id]) return fm[col.id](value, row);

          return (
            <Box
              sx={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={value !== null && value !== undefined ? String(value) : ""}
            >
              {value !== null && value !== undefined ? String(value) : ""}
            </Box>
          );
        },
      };
    });

    // Handle pagination
    const handlePageChange = (newPage: number) => {
      if (isRemote && onRemotePageChange) {
        onRemotePageChange(null, newPage);
      } else {
        this.onPageChange(newPage);
      }
    };

    const handlePageSizeChange = (newPageSize: number) => {
      if (isRemote && onRemoteRowsPerPageChange) {
        onRemoteRowsPerPageChange({ target: { value: newPageSize } });
      } else {
        this.onPageSizeChange(newPageSize);
      }
    };

    
    return (
      <Paper
        elevation={0}
        sx={{
          width: 1,
          maxWidth: '100%',
          minWidth: 0,
          boxSizing: 'border-box',
          mt: 1,
          border: '1px solid #E2E8EE',
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <GridToolbar
          title={title}
          numSelected={selected.length}
          selectedRecord={selectedRecord}
          handleSelect={handleSelect}
          onAction={onAction}
          refresh={refresh}
          actions={actions}
          actionSet={actionSet}
          setColumns={setColumns}
          rowCount={rowCount}
          cols={rows}
          fcols={frows}
          sdata={sdata}
          srecords={data}
          filterOpen={this.state.filterOpen}
          onToggleFilter={this.toggleFilter}
        />
        <Collapse in={this.state.filterOpen} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 2,
              py: 1.5,
              borderBottom: '1px solid #E2E8EE',
              backgroundColor: '#F8FAFB',
            }}
          >
            {/* <GridFilterPanel
              fields={frows}
              query={query}
              onApply={this.handleFilterApply}
              onReset={this.handleFilterReset}
              onClose={this.closeFilter}
    
              sdata={sdata}
              rows={rows}
              fcols={frows}
              //onClose={this.closeFilter}
              search={search}
              //query={query}
            /> */}
            <GridAdvancedFilterPanel
              sdata={sdata}
              value={this.state.filterModel}
              query={query}
              onApply={this.handleAdvancedFilterApply}
              onChange={(model: any) => this.setState({ filterModel: model })}
              onReset={() => {
                this.setState({
                  filterModel: { search: "", defaultField: sdata?.menu?.def || "", conditions: [] },
                });
                refresh?.({});
              }}
              onClose={this.closeFilter}
              onOpenAi={this.openAi}
            />
            
            <AIQueryAssistant
              open={this.state.aiOpen}
              sdata={sdata}
              onClose={this.closeAi}
              onApply={this.handleAdvancedFilterApply}
            />
          </Box>
        </Collapse>
        {/* <Box sx={{...s.tableWrapper, height: 600 }}> */}
        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            minHeight: 520,
            height: 'calc(100vh - 280px)',
            maxHeight: 1000,
            overflow: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          <DataGrid
            rows={data || []}
            columns={columns}
            getRowId={(row) => {
              if (row.id !== undefined && row.id !== null) return row.id;
              if (row.rid !== undefined && row.rid !== null) return row.rid;
              // Fallback: use index if no ID is available
              const index = (data || []).indexOf(row);
              return index >= 0 ? `row-${index}` : `row-${Math.random()}`;
            }}
            rowCount={rowCount || 0}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            paginationModel={{ page, pageSize: rowsPerPage }}
            onPaginationModelChange={(model) => {
              handlePageChange(model.page);
              handlePageSizeChange(model.pageSize);
            }}
            sortModel={sortModel || []}
            onSortModelChange={this.onSortModelChange}
            onRowClick={(e)=>this.onRowSelect(e,e.row)}
            checkboxSelection
            disableMultipleRowSelection
            disableRowSelectionOnClick={false}
            hideFooterSelectedRowCount={true}
            paginationMode={isRemote ? 'server' : 'client'}
            sortingMode={isRemote ? 'server' : 'client'}
            autoHeight={false}
            sx={{ ...s.datagrid }}
          />
        </Box>
      </Paper>
    );
  }
}

export default GridPanel;
